import { render } from "./AdminPurchaseRefundAppeals.vue?vue&type=template&id=0a67f3e8&scoped=true"
import script from "./AdminPurchaseRefundAppeals.vue?vue&type=script&lang=js"
export * from "./AdminPurchaseRefundAppeals.vue?vue&type=script&lang=js"

import "./AdminPurchaseRefundAppeals.vue?vue&type=style&index=0&id=0a67f3e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a67f3e8"]])

export default __exports__